const CoinGetter = {
    coinType: state => state.coinType,
    coinPreferences: state => state.coinPreferences,
    openOrders: state => state.openOrders,
    pendingOrders: state => state.pendingOrders
};

export default CoinGetter;